import { appLocalStorage } from '@/app/shared/commonURLs';

let PatientSearchODataURL = appLocalStorage.PatientSearchODataURL;
 

export class uRls {
    constructor() {
         
        this.PatientSearchServicesList = PatientSearchURLs();
    }
}

const PatientSearchURL = new uRls();
export { PatientSearchURL };


function PatientSearchURLs() {

    var services = {};
    //================ Fiscal Period Services ======================
    services["QuickFindPatient"] = {
        Method: 'Get',
        URL: PatientSearchODataURL + 'QuickFindPatient',
    }
     
    return services
}
 

 